import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

import CanStoreLogin from 'pages/can-store/CanStoreLogin';
import ModernTemplateHome from 'pages/can-store/modern/ModernTemplateHome';
import ModernTemplateProduct from 'pages/can-store/modern/ModernTemplateProduct';
import ModernTemplateShoppingCart from 'pages/can-store/modern/ModernTemplateShoppingCart';
import CanStorePrivateRoute from './CanStorePrivateRoute';
import ModernTemplateLayout from './ModernTemplateLayout';

import muiModernTemplateTheme from 'styles/can-store/modern-template/muiModernTemplateTheme';

function CanStoreDesignSwitcher(): JSX.Element {
	return (
		<ThemeProvider theme={muiModernTemplateTheme}>
			<CssBaseline />
			<StyledEngineProvider injectFirst>
				<Routes>
					<Route path="login" element={<CanStoreLogin />} />
					<Route path="/" element={<ModernTemplateLayout />}>
						<Route path="/" element={<ModernTemplateHome />} />
						<Route path="product" element={<ModernTemplateProduct />} />
						<Route
							path="cart"
							element={
								<CanStorePrivateRoute>
									<ModernTemplateShoppingCart />
								</CanStorePrivateRoute>
							}
						/>
					</Route>
				</Routes>
			</StyledEngineProvider>
		</ThemeProvider>
	);
}

export default CanStoreDesignSwitcher;
